import { ApplicationConfig, inject, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './core/global-error-handler';
import { DownloadService } from './core/download.service';
import { provideRouter } from '@angular/router';
import { APP_INITIALIZER } from '@angular/core';
import { UserStateService } from './core/user-state.service';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { OepaAuthProfile, OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { environment } from '../environments/environment';
import { OAuthService, provideOAuthClient, UrlHelperService } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JWTHttpInterceptor } from '../shared/jwt-http-interceptor';
import { LoadingInterceptor } from './core/loading/loading.interceptor';

const profile: OepaAuthProfile = {
  clientId: environment.clientID,
  redirectUri: environment.redirectURI
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: OepaIopAuthLibService,
      useFactory: () => {
        return new OepaIopAuthLibService(inject(OAuthService), profile)
      }
    },
    provideOAuthClient(),
    UrlHelperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTHttpInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUserState,
      deps: [UserStateService],
      multi: true
    },
  ]
};

export function initializeUserState(userStateService: UserStateService) {
  return () => userStateService.loadUserState();
}
